import dayjs, { Dayjs } from 'dayjs';
import { PickersShortcutsItem } from '@mui/x-date-pickers-pro';
import { DateRange } from '@mui/x-date-pickers-pro';

const today = dayjs();
const disabledYear = dayjs().year(1999); // for disabling first item

export const shourtcutsItems: PickersShortcutsItem<DateRange<Dayjs>>[] = [
  {
    label: 'Date presets',
    getValue: () => {
      return [disabledYear, disabledYear];
    },
  },
  {
    label: 'all time',
    getValue: () => [null, null],
  },
  {
    label: 'yesterday',
    getValue: () => {
      const yesterday = today.subtract(1, 'day');
      return [yesterday, yesterday];
    },
  },
  {
    label: 'last 7 days',
    getValue: () => [today.subtract(7, 'day'), today],
  },
  {
    label: 'last 30 days',
    getValue: () => [today.subtract(30, 'day'), today],
  },
  {
    label: 'last month',
    getValue: () => {
      const month = today.subtract(1, 'month');
      const start = month.startOf('month');
      const end = month.endOf('month');
      return [start, end];
    },
  },
  {
    label: 'last year',
    getValue: () => {
      const year = today.subtract(1, 'year');
      const start = year.startOf('year');
      const end = year.endOf('year');
      return [start, end];
    },
  },
];
